import React from 'react'

const OpcionesCategorias = ({ history, opcionPrincipal, handleOptionSelected, setItemSelected, setitemTitulo, principales, step, setStep, subCategoriaMarca }) => {
    return (
        <div className="gridOptions-second">
            <div className={"gridOptions-second-body"}>
                {
                    principales
                        .sort((p1, p2) => p1.orden - p2.orden)
                        .slice(0, 11)
                        .map(
                            (c, i) => {
                                return (
                                    <button
                                        key={i + c.titulo}
                                        className={subCategoriaMarca[i] == 1 ? "selected" : ""}
                                        onClick={
                                            (e) => {
                                                handleOptionSelected(e, c.id, ".gridOptions-second", i);
                                                setItemSelected(c.id + "");
                                                setitemTitulo(c.titulo);
                                                //definir paso
                                                step < 2 && setStep(2);
                                            }
                                        }
                                    >{c.titulo}</button>
                                )
                            }
                        )
                }
            </div>
            <div className="gridOptions-second-footer">
                <a
                    onClick={
                        () => {
                            let categoria = "Categoria";
                            history.push({
                                pathname: '/Catalogo/' + categoria + '/' + "-1" + '/' + "Todos/1",
                            })
                        }
                    }
                >Ver todas las {opcionPrincipal == 'categoria_id' ? 'categorías' : "marcas"}</a>
            </div>

        </div>
    )
}

export default OpcionesCategorias;
